import { render, staticRenderFns } from "./SeatSelectionCard.vue?vue&type=template&id=64a1041a"
import script from "./SeatSelectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatSelectionCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports